import { Fragment } from 'react'

import {
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from '@mui/material'

export const NotificationListSkeleton = () => {
  return (
    <List sx={{ width: '100%', maxWidth: 800, mt: 0, py: 0 }}>
      {[1, 2, 3, 4, 5].map(item => (
        <Fragment key={item}>
          {item === 1 && <Divider />}
          <ListItem sx={{ width: '100%', p: 0 }}>
            <ListItemButton alignItems="center" sx={{ px: 2, py: 1 }}>
              <ListItemIcon sx={{ minWidth: 'initial', mr: 2 }}>
                <Skeleton height={20} variant="rectangular" width={20} />
              </ListItemIcon>
              <ListItemAvatar>
                <Skeleton height={40} variant="circular" width={40} />
              </ListItemAvatar>
              <ListItemText
                primary={<Skeleton />}
                secondary={
                  <>
                    <Skeleton width="80%" />
                    <Skeleton width="20%" />
                  </>
                }
                sx={{ pt: 1 }}
              />
            </ListItemButton>
          </ListItem>
          <Divider />
        </Fragment>
      ))}
    </List>
  )
}
